import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import userServices from "../../api/services/userService";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import filterService from "../../api/services/filterService";
import { countries } from "../../data/countries";
const UserProfiles = () => {
  const navigate = useNavigate();

  // Filters
  const [filters, setFilters] = useState({
    occupation: "",
    education: "",
    marital: "",
    religion: "",
    minHeight: "",
    maxHeight: "",
    minAge: "",
    maxAge: "",
    radius: "",
    latitude: "",
    longitude: "",
    country: "",
    sort: "",
  });

  // Pagination states (same logic as TopUsers)
  const [backendPage, setBackendPage] = useState(1);
  const backendLimit = 50;

  const [frontendPage, setFrontendPage] = useState(1);
  const frontendLimit = 15;

  // Data states
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Filter lists
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [education, setEducation] = useState([]);
  const [religions, setReligion] = useState([]);
  const [occupation, setOccupation] = useState([]);

  // Handle filter input
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // Fetch users (backend page)
  const fetchFilteredUsers = async () => {
    try {
      setIsLoading(true);

      const payload = {
        ...filters,

        // Convert single-select values to array (if not empty)
        occupation: filters.occupation ? [Number(filters.occupation)] : null,
        education: filters.education ? [Number(filters.education)] : null,
        marital: filters.marital ? [Number(filters.marital)] : null,
        religion: filters.religion ? [Number(filters.religion)] : null,

        // Country already array OR empty
        country: filters.country ? [filters.country] : null,

        minHeight: filters.minHeight ? Number(filters.minHeight) : null,
        maxHeight: filters.maxHeight ? Number(filters.maxHeight) : null,
        minAge: filters.minAge ? Number(filters.minAge) : null,
        maxAge: filters.maxAge ? Number(filters.maxAge) : null,
      };

      const result = await userServices.getFilteredUsersAdmin(payload);
      const allUsers = result?.users || [];

      setUsers(allUsers);
      setTotal(result?.total || 0);
      setFrontendPage(1);
    } catch (error) {
      console.error("Error fetching filtered users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFilteredUsers();
  }, [backendPage]);

  useEffect(() => {
    const loadFilterData = async () => {
      const data = await filterService.getAllFilters();
      setMaritalStatus(data.maritalStatus);
      setEducation(data.educations);
      setOccupation(data.occupations);
      setReligion(data.religions);
    };
    loadFilterData();
  }, []);

  // --- FRONTEND PAGINATION LOGIC (same as TopUsers) ---
  const paginatedUsers = users.slice(
    (frontendPage - 1) * frontendLimit,
    frontendPage * frontendLimit
  );

  const handleNext = () => {
    if (frontendPage * frontendLimit >= users.length) {
      setBackendPage((p) => p + 1);
      return;
    }
    setFrontendPage((p) => p + 1);
  };

  const handlePrev = () => {
    if (frontendPage === 1 && backendPage > 1) {
      setBackendPage((p) => p - 1);
      setFrontendPage(4);
      return;
    }
    if (frontendPage > 1) setFrontendPage((p) => p - 1);
  };

  return (
    <div className="p-4 w-full">
      {/* FILTER SECTION */}
      <div className="bg-white p-4 rounded shadow mb-4 grid grid-cols-4 gap-4">
        {/* Occupation */}
        <select
          name="occupation"
          value={filters.occupation}
          onChange={handleFilterChange}
          className="border p-2 rounded">
          <option value="">Select Occupations</option>
          {occupation?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Education */}
        <select
          name="education"
          value={filters.education}
          onChange={handleFilterChange}
          className="border p-2 rounded">
          <option value="">Select Education</option>
          {education?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Marital Status */}
        <select
          name="marital"
          value={filters.marital}
          onChange={handleFilterChange}
          className="border p-2 rounded">
          <option value="">Select Marital Status</option>
          {maritalStatus?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Religion */}
        <select
          name="religion"
          value={filters.religion}
          onChange={handleFilterChange}
          className="border p-2 rounded">
          <option value="">Select Religion</option>
          {religions?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Other filter fields */}
        <input
          type="number"
          name="minAge"
          placeholder="Min Age"
          value={filters.minAge}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          name="maxAge"
          placeholder="Max Age"
          value={filters.maxAge}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          name="minHeight"
          placeholder="Min Height"
          value={filters.minHeight}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          name="maxHeight"
          placeholder="Max Height"
          value={filters.maxHeight}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />

        {/* Countries */}
        <select
          name="country"
          value={filters.country}
          onChange={handleFilterChange}
          className="border p-2 rounded">
          <option value="">Select Countries</option>
          {countries?.map((item) => (
            <option key={item.id} value={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          name="latitude"
          placeholder="Latitude"
          value={filters.latitude}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />
        <input
          type="text"
          name="longitude"
          placeholder="Longitude"
          value={filters.longitude}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          name="radius"
          placeholder="Radius (meters)"
          value={filters.radius}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        />

        {/* Apply / Clear */}
        <div className="col-span-4 flex justify-between mt-2">
          <button
            onClick={() => {
              setBackendPage(1);
              setFrontendPage(1);
              fetchFilteredUsers();
            }}
            className="bg-red-500 text-white py-2 px-4 rounded">
            Apply Filters
          </button>

          <button
            onClick={() => {
              setFilters({
                occupation: "",
                education: "",
                marital: "",
                religion: "",
                minHeight: "",
                maxHeight: "",
                minAge: "",
                maxAge: "",
                radius: "",
                latitude: "",
                longitude: "",
                country: "",
                sort: "",
              });
              setBackendPage(1);
              setFrontendPage(1);
              fetchFilteredUsers();
            }}
            className="bg-gray-300 text-black py-2 px-4 rounded">
            Clear Filters
          </button>
        </div>
      </div>

      {/* TABLE */}
      {isLoading ? (
        <Loading />
      ) : (
        <div className="overflow-x-auto bg-white shadow rounded-lg">
          <table className="w-full text-left border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2">SR. NO</th>
                <th className="px-4 py-2">First Name</th>
                <th className="px-4 py-2">Last Name</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Gender</th>
                <th className="px-4 py-2">Contact No</th>
                <th className="px-4 py-2">Age</th>
                <th className="px-4 py-2">Height</th>
                <th className="px-4 py-2">GrewUp</th>
                <th className="px-4 py-2">Occupation</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((user, idx) => (
                  <tr key={user.id} className="border-t">
                    <td className="px-4 py-2">
                      {(frontendPage - 1) * frontendLimit + idx + 1}
                    </td>
                    <td className="px-4 py-2">{user.firstName}</td>
                    <td className="px-4 py-2">{user.lastName}</td>
                    <td className="px-4 py-2">{user.email}</td>
                    <td className="px-4 py-2">{user.gender}</td>
                    <td className="px-4 py-2">{user.contactNo}</td>
                    <td className="px-4 py-2">{user.age}</td>
                    <td className="px-4 py-2">{user.height}</td>
                    <td className="px-4 py-2">{user.grewUp}</td>
                    <td className="px-4 py-2">{user.occupation}</td>

                    <td className="px-4 py-2">
                      <FaEye
                        className="text-red-500 cursor-pointer"
                        onClick={() => {
                          window.open(
                            `https://naseebi.com/home/profiledetail/${user.id}`,
                            "_blank"
                          );
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-gray-500">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* PAGINATION — same style as TopUsers */}
      <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
        <span>Rows per page: {frontendLimit}</span>

        <span>
          {(frontendPage - 1) * frontendLimit + 1}–
          {Math.min(frontendPage * frontendLimit, users.length)} of{" "}
          {users.length}
          <button
            className="ml-2 px-2"
            disabled={frontendPage === 1 && backendPage === 1}
            onClick={handlePrev}>
            &lt;
          </button>
          <button className="px-2" onClick={handleNext}>
            &gt;
          </button>
        </span>
      </div>
    </div>
  );
};

export default UserProfiles;
